<template>
  <div
    class="p-4 md:p-6 lg:p-8 xl:p-10 bg-app-bg-light dark:bg-app-bg-dark min-h-screen"
  >
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-slate-800 dark:text-slate-100 mb-2">
        Panel de Mesero
      </h1>
      <p class="text-slate-600 dark:text-slate-400">
        Gestión de pedidos - {{ fechaActual }}
      </p>
    </div>

    <!-- Filtro de Turno -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-5 shadow-sm mb-8"
    >
      <h2
        class="text-base font-semibold text-slate-700 dark:text-slate-200 mb-3 flex items-center gap-2"
      >
        <i class="bx bx-filter-alt text-custom-primary"></i> Filtro de Turno
      </h2>
      <div class="flex flex-wrap gap-4 items-end">
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Desde</label
          >
          <input
            type="datetime-local"
            v-model="filtro.fechaInicio"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Hasta</label
          >
          <input
            type="datetime-local"
            v-model="filtro.fechaFin"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <button
          @click="cargarStats"
          class="bg-custom-primary hover:opacity-90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-opacity border-0"
        >
          <i class="bx bx-refresh mr-1"></i>Actualizar
        </button>
      </div>
    </div>

    <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm mb-8">
      <h2 class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6">
        Acciones Rápidas
      </h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <button
          @click="$router.push('/seleccionar-mesa')"
          class="flex flex-col items-center p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 shadow-md hover:shadow-lg transition-all group border-0"
        >
          <i
            class="bx bx-plus-circle text-4xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span class="text-sm text-slate-700 dark:text-slate-300"
            >Nuevo Pedido</span
          >
        </button>
        <button
          @click="$router.push('/cuentas-pendientes-mesas')"
          class="flex flex-col items-center p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 shadow-md hover:shadow-lg transition-all group border-0"
        >
          <i
            class="bx bx-receipt text-4xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span class="text-sm text-slate-700 dark:text-slate-300"
            >Cuentas Pendientes</span
          >
        </button>
      </div>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div
          class="p-3 bg-yellow-100 dark:bg-yellow-900/30 rounded-lg w-fit mb-3"
        >
          <i
            class="bx bx-time text-3xl text-yellow-600 dark:text-yellow-400"
          ></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          {{ stats.pedidosActivos }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">
          Pedidos Activos
        </p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div class="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg w-fit mb-3">
          <i
            class="bx bx-restaurant text-3xl text-blue-600 dark:text-blue-400"
          ></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          {{ stats.mesasOcupadas }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">Mesas Ocupadas</p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div
          class="p-3 bg-green-100 dark:bg-green-900/30 rounded-lg w-fit mb-3"
        >
          <i
            class="bx bx-dollar text-3xl text-green-600 dark:text-green-400"
          ></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          Q{{ parseFloat(stats.ventasHoy).toFixed(2) }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">Ventas Hoy</p>
      </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <h2
          class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6"
        >
          Mesas Asignadas
        </h2>
        <div
          v-if="mesas.length === 0"
          class="text-center text-slate-500 dark:text-slate-400 py-8"
        >
          No hay mesas activas en este momento
        </div>
        <div v-else class="space-y-3">
          <div
            v-for="mesa in mesas"
            :key="mesa.numero"
            class="flex items-center justify-between p-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700"
          >
            <div class="flex items-center gap-3">
              <div
                class="w-12 h-12 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center"
              >
                <span class="font-bold text-blue-600 dark:text-blue-400">{{
                  mesa.numero
                }}</span>
              </div>
              <div>
                <p class="font-medium text-slate-800 dark:text-slate-100">
                  {{ mesa.comensales }} personas
                </p>
                <p class="text-sm text-slate-500 dark:text-slate-400">
                  {{ mesa.tiempo }}
                </p>
              </div>
            </div>
            <span
              :class="[
                mesa.estado === 'Ordenado'
                  ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400'
                  : 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
                'text-xs px-3 py-1 rounded-full',
              ]"
              >{{ mesa.estado }}</span
            >
          </div>
        </div>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <h2
          class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6"
        >
          Pedidos Listos
        </h2>
        <div
          v-if="pedidosListos.length === 0"
          class="text-center text-slate-500 dark:text-slate-400 py-8"
        >
          No hay pedidos listos para servir
        </div>
        <div v-else class="space-y-3">
          <div
            v-for="pedido in pedidosListos"
            :key="pedido.id"
            class="p-3 rounded-lg bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800"
          >
            <div class="flex items-center justify-between mb-2">
              <div>
                <p class="font-medium text-slate-800 dark:text-slate-100">
                  Mesa {{ pedido.mesa }}
                </p>
                <p class="text-sm text-slate-600 dark:text-slate-400">
                  {{ pedido.items }}
                </p>
              </div>
              <div class="flex items-center gap-2">
                <span
                  class="text-xs bg-green-600 text-white px-2 py-1 rounded-full"
                  >Listo</span
                >
                <button
                  @click="marcarComoEntregado(pedido.id)"
                  class="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-full transition-colors border-0"
                  title="Marcar como entregado"
                >
                  <i class="bx bx-check"></i> Entregado
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Alertas de inventario -->
    <div
      v-if="alertasInventario.length > 0"
      class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-6 shadow-sm mb-8"
    >
      <h2
        class="text-xl font-semibold text-red-800 dark:text-red-300 mb-4 flex items-center"
      >
        <i class="bx bx-error-circle text-2xl mr-2"></i>
        Alertas de Inventario
      </h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        <div
          v-for="(alerta, i) in alertasInventario"
          :key="i"
          class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-red-300 dark:border-red-700"
        >
          <p class="font-medium text-sm text-slate-800 dark:text-slate-100">
            {{ alerta.nombre }}
          </p>
          <div class="flex justify-between items-center mt-1">
            <span class="text-xs text-slate-600 dark:text-slate-400">{{
              alerta.area
            }}</span>
            <span class="text-xs font-bold text-red-600 dark:text-red-400">
              Stock: {{ alerta.stock }} / {{ alerta.stock_minimo }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "../../config/config.js";

export default {
  name: "DashboardMesero",
  data() {
    // Turno restaurante: 6am hoy → 11pm hoy
    const hoy = new Date();
    const inicio = new Date(hoy);
    inicio.setHours(6, 0, 0, 0);
    const fin = new Date(hoy);
    fin.setHours(23, 0, 0, 0);
    const toLocal = (d) =>
      new Date(d - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    return {
      loading: true,
      filtro: {
        fechaInicio: toLocal(inicio),
        fechaFin: toLocal(fin),
      },
      stats: { pedidosActivos: 0, mesasOcupadas: 0, ventasHoy: 0 },
      mesas: [],
      pedidosListos: [],
      alertasInventario: [],
      cantidadPedidosListosAnterior: 0,
      sonidoPedidoListo: null,
    };
  },
  computed: {
    fechaActual() {
      return new Date().toLocaleDateString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  methods: {
    async cargarStats() {
      try {
        this.loading = true;
        const response = await axios.get(`${API_URL}/dashboard/mesero`, {
          params: {
            fecha_inicio: this.filtro.fechaInicio,
            fecha_fin: this.filtro.fechaFin,
          },
        });

        this.stats.pedidosActivos = response.data.pedidosActivos || 0;
        this.stats.mesasOcupadas = response.data.mesasOcupadas || 0;
        this.stats.ventasHoy = response.data.ventasHoy || 0;

        this.loading = false;
      } catch (error) {
        console.error("Error cargando estadísticas:", error);
        this.loading = false;
      }
    },
    async cargarMesas() {
      try {
        const response = await axios.get(`${API_URL}/dashboard/mesas-activas`);
        this.mesas = response.data.map((item) => ({
          numero: item.NumeroMesa,
          comensales: item.CantidadPersonas || 0,
          tiempo: this.calcularTiempo(item.FechaHora),
          estado: item.Estado,
        }));
      } catch (error) {
        console.error("Error cargando mesas:", error);
      }
    },
    async cargarPedidosListos() {
      try {
        const response = await axios.get(`${API_URL}/dashboard/pedidos-listos`);
        const nuevosPedidos = response.data.map((item) => ({
          id: item.IdPedido,
          mesa: item.NumeroMesa,
          items: item.Items || "Sin items",
        }));

        // Si hay más pedidos listos que antes, reproducir sonido
        if (
          nuevosPedidos.length > this.cantidadPedidosListosAnterior &&
          this.cantidadPedidosListosAnterior > 0
        ) {
          this.reproducirSonidoPedidoListo();
        }

        this.cantidadPedidosListosAnterior = nuevosPedidos.length;
        this.pedidosListos = nuevosPedidos;
      } catch (error) {
        console.error("Error cargando pedidos listos:", error);
      }
    },
    reproducirSonidoPedidoListo() {
      if (this.sonidoPedidoListo) {
        this.sonidoPedidoListo.currentTime = 0;
        this.sonidoPedidoListo.volume = 1.0;
        this.sonidoPedidoListo.play().catch(() => {
          // Silenciar error de reproducción de audio
        });
      }
    },
    calcularTiempo(fechaHora) {
      const ahora = new Date();
      const fecha = new Date(fechaHora);
      const minutos = Math.floor((ahora - fecha) / 60000);
      if (minutos < 60) return `${minutos} min`;
      const horas = Math.floor(minutos / 60);
      return `${horas}h ${minutos % 60}min`;
    },
    async cargarAlertasInventario() {
      try {
        const response = await axios.get(
          `${API_URL}/dashboard/alertas-inventario-restaurante`,
        );
        this.alertasInventario = response.data || [];
      } catch (error) {
        console.error("Error cargando alertas de inventario:", error);
      }
    },
    async marcarComoEntregado(idPedido) {
      try {
        await axios.put(`${API_URL}/dashboard/pedido-entregado/${idPedido}`);
        // Recargar la lista inmediatamente
        await this.cargarPedidosListos();
      } catch (error) {
        console.error("Error marcando pedido como entregado:", error);
      }
    },
  },
  mounted() {
    // Inicializar sonido de pedido listo
    this.sonidoPedidoListo = new Audio("/sonidos/pedido_listo.mp3");

    this.cargarStats();
    this.cargarMesas();
    this.cargarPedidosListos();
    this.cargarAlertasInventario();

    // Auto-actualización cada 5 segundos
    setInterval(() => {
      this.cargarStats();
      this.cargarMesas();
      this.cargarPedidosListos();
      this.cargarAlertasInventario();
    }, 5000);
  },
};
</script>
